/**
 * The install suggestion's "don't show this again" flag: one `localStorage`
 * key, read and written here. A plain module rather than a `.svelte.ts` one,
 * like `personal-bests-io.ts`, so it is unit-testable with no reactive
 * harness. `screens/PlayTab.svelte` reads the flag once, on mount: once
 * dismissed on a device, the card has no reason to come back on it, however
 * many times the browser offers the prompt again.
 */
import { safeLocalStorage } from './settings-io.js';

export const INSTALL_BANNER_DISMISSED_KEY = 'interlock:install-banner-dismissed:v1';

/** `storage` defaults to `localStorage`, injectable so this stays testable without a real browser. */
export function isInstallBannerDismissed(
  storage: Storage | undefined = safeLocalStorage(),
): boolean {
  if (storage === undefined) return false;
  try {
    return storage.getItem(INSTALL_BANNER_DISMISSED_KEY) !== null;
  } catch {
    return false;
  }
}

export function dismissInstallBanner(storage: Storage | undefined = safeLocalStorage()): void {
  if (storage === undefined) return;
  try {
    storage.setItem(INSTALL_BANNER_DISMISSED_KEY, '1');
  } catch {
    // Storage full or blocked (private browsing) — the banner just cannot
    // remember; showing again next visit is the harmless failure mode, the
    // same policy `settings-io.ts`'s own `writeStore` documents.
  }
}
